export const detectIE = (): boolean => {
  // @ts-ignore
  return !!window.document.documentMode
}

export const getPagePosition = (element: Element | null): { left: number, top: number } => {
  if (!element) return { left: 0, top: 0 }
  const { scrollTop, scrollLeft } = element
  return { left: scrollLeft, top: scrollTop }
}

export function getBrowserWidth () {
  return Math.max(
    document.body.scrollWidth,
    document.documentElement.scrollWidth,
    document.body.offsetWidth,
    document.documentElement.offsetWidth,
    document.documentElement.clientWidth
  )
}

export function getBrowserHeight () {
  return Math.max(
    document.body.scrollHeight,
    document.documentElement.scrollHeight,
    document.body.offsetHeight,
    document.documentElement.offsetHeight,
    document.documentElement.clientHeight
  )
}

export function distanceFromEdges (element: HTMLElement) {
  const { bottom, top, left, right } = element.getBoundingClientRect()
  return {
    bottom: window.innerHeight - bottom,
    top,
    left,
    right: getBrowserWidth() - right
  }
}
